import { createLazyComponent, LazyModule } from 'owa-bundling';
import { RsvpUnitSkeleton } from 'mini-mail-rsvp-view/lib/components/RsvpUnitSkeleton';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MailListRsvpView" */ './lazyIndex')
);

export const ListViewRsvpUnit = createLazyComponent(
    lazyModule,
    m => m.ListViewRsvpUnit,
    RsvpUnitSkeleton
);

export { ListViewRsvpUnitProps } from './schema/ListViewRsvpUnit.types';
